import { Modal, modalWidth, Layout as OrigLayout } from "@hubrise/react-components"
import type { PageHeaderProps } from "@hubrise/react-components"
import * as React from "react"
import { ForwardedRef } from "react"

import { useConfig } from "shared/components/ConfigContext"
import SettingsModalContent from "shared/components/SettingsModalContent"
import { useAccountQuery } from "shared/hooks/queries"
import useAppNavigation from "shared/hooks/useAppNavigation"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"

interface LayoutProps {
  children: React.ReactNode
  links?: PageHeaderProps["links"]
  catalogSelector?: JSX.Element
  toolbar?: JSX.Element
  hasPopupOverlay?: boolean
}

const Layout = React.forwardRef(
  (
    { children, links = [], catalogSelector, toolbar, hasPopupOverlay = false }: LayoutProps,
    $contentRef: ForwardedRef<HTMLDivElement>,
  ): JSX.Element => {
    const { withAppInstanceId } = useAppNavigation()
    const navigate = useNavigateNoUpdate()
    const {
      appInstanceId,
      images: { logo },
    } = useConfig()
    const [isSettingsOpen, setIsSettingsOpen] = React.useState(false)

    const { data: account } = useAccountQuery(appInstanceId)

    const logoLink = withAppInstanceId("/")

    return (
      <>
        <OrigLayout
          ref={$contentRef}
          pageHeader={{
            accountOrLocation: account ?? { name: "...", id: "..." },
            logo,
            logoLink: {
              href: logoLink,
              onClick: () => navigate(logoLink),
            },
            links,
            settingsOnClick: () => setIsSettingsOpen(true),
            desktopRightHandSide: catalogSelector,
            bottomShadow: toolbar === undefined,
          }}
          toolbar={toolbar}
          hasPopupOverlay={hasPopupOverlay}
        >
          {children}
        </OrigLayout>

        {isSettingsOpen && (
          <Modal
            modalWidth={modalWidth.medium}
            onClose={() => setIsSettingsOpen(false)}
            renderContent={({ close }) => <SettingsModalContent close={close} />}
          />
        )}
      </>
    )
  },
)

Layout.displayName = "Layout"

export default Layout
